/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PublicApiRequestAudit
 */
export interface PublicApiRequestAudit {
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  auditId?: string;
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  shipmentId?: string;
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  apiKeyId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof PublicApiRequestAudit
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  method?: string;
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  path?: string;
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  requestHeaders?: string;
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  requestBody?: string;
  /**
   *
   * @type {number}
   * @memberof PublicApiRequestAudit
   */
  responseStatus?: number;
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  responseBody?: string;
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  traceId?: string;
  /**
   *
   * @type {string}
   * @memberof PublicApiRequestAudit
   */
  userAgent?: string;
  /**
   *
   * @type {number}
   * @memberof PublicApiRequestAudit
   */
  durationMs?: number;
}

/**
 * Check if a given object implements the PublicApiRequestAudit interface.
 */
export function instanceOfPublicApiRequestAudit(
  value: object,
): value is PublicApiRequestAudit {
  return true;
}

export function PublicApiRequestAuditFromJSON(
  json: any,
): PublicApiRequestAudit {
  return PublicApiRequestAuditFromJSONTyped(json, false);
}

export function PublicApiRequestAuditFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PublicApiRequestAudit {
  if (json == null) {
    return json;
  }
  return {
    auditId: json["auditId"] == null ? undefined : json["auditId"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    apiKeyId: json["apiKeyId"] == null ? undefined : json["apiKeyId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    method: json["method"] == null ? undefined : json["method"],
    path: json["path"] == null ? undefined : json["path"],
    url: json["url"] == null ? undefined : json["url"],
    requestHeaders:
      json["requestHeaders"] == null ? undefined : json["requestHeaders"],
    requestBody: json["requestBody"] == null ? undefined : json["requestBody"],
    responseStatus:
      json["responseStatus"] == null ? undefined : json["responseStatus"],
    responseBody:
      json["responseBody"] == null ? undefined : json["responseBody"],
    traceId: json["traceId"] == null ? undefined : json["traceId"],
    userAgent: json["userAgent"] == null ? undefined : json["userAgent"],
    durationMs: json["durationMs"] == null ? undefined : json["durationMs"],
  };
}

export function PublicApiRequestAuditToJSON(json: any): PublicApiRequestAudit {
  return PublicApiRequestAuditToJSONTyped(json, false);
}

export function PublicApiRequestAuditToJSONTyped(
  value?: PublicApiRequestAudit | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    auditId: value["auditId"],
    shipmentId: value["shipmentId"],
    companyId: value["companyId"],
    apiKeyId: value["apiKeyId"],
    createdAt: value["createdAt"],
    method: value["method"],
    path: value["path"],
    url: value["url"],
    requestHeaders: value["requestHeaders"],
    requestBody: value["requestBody"],
    responseStatus: value["responseStatus"],
    responseBody: value["responseBody"],
    traceId: value["traceId"],
    userAgent: value["userAgent"],
    durationMs: value["durationMs"],
  };
}
